// Copyright 2022-2026 - Hewlett Packard Enterprise Company
export const CONTENT_IDS = {
  ADD_DEVICES: 'cc_add_devices',
  ANNOUNCEMENTS: 'cc_announcements',
  ACTIVATE_DEVICES: 'cc_activate_devices',
  KNOWN_ISSUES: 'cc_issues_limitations',
  RESOLVED_ISSUES: 'com_resolved_issues',
  SERVER_ACTIONS: 'cc_server_actions',
  SERVER_GROUP: 'cc_server_group',
  SET_FIRMWARE_BASELINES: 'cc_set_baselines', // set initial baselines
  UPDATE_FIRMWARE_BASELINES: 'cc_fw_baselines', // general f/w update
  UPDATE_GROUP_FIRMWARE_BASELINES: 'com_group_baseline',
  DOWNLOAD_FIRMWARE_BASELINES: 'com_download_firmware',
  STATUS_VALUES: 'com_status_values',
  BIOS_SETTINGS: 'com_bios_settings',
  SW_DRIVERS: 'com_sw_drivers',
  UPDATE_GROUP_LOCAL_STORAGE_SETTINGS: 'com_server_group_storage',
  OV_SERVER_TEMPLATES: 'com_ov_appliance_server_template_settings',
  UPDATE_APPLIANCE_FIRMWARE: 'com_appliance_firmware',
  AUTO_ADD_SERVERS: 'com_automate_add',
  SERVER_SETTING_BASELINE: 'com_serversetting_baseline',
  SERVER_SETTINGS_ACTIONS: 'com_serversetting_action_ref',
  SETTING_APPLIANCE_SOFTWARE: 'com_setting_appliance_software',
  AUTO_ILO_FW_UPDATE_ACTION: 'com_action_auto_ilo_fw',
  GROUP_SETTINGS: 'com_group_settings',
  GROUP_POLICIES: 'com_group_policies',
  SAVED_FILTERS: 'com_saved_filters',
  SBAC_BASED_FILTERS: 'com_saved_filters',
  OS_IMAGE: 'com_serversetting_osimage',
  RUN_CARBON_REPORT: '',
  COM_METRICS_DATA_COLLECTION: 'com_metrics_data_collection',
  COM_UTILIZATION_ALERTS: 'com_utilization_alerts',
  COM_SERVER_ALERTS: 'com_server_alerts',
  SERVER_HW_INVENTORY_REPORT: 'com_server_hardware_inv_report',
  ONEVIEW_APPLIANCES: 'ov_oneview_appliances',
  RENEW_OV_SUBSCRIPTION: 'ov_service_subscription_renew',
  CANCEL_FW_UPDATE: 'com_cancel_fwu',
  SERVICE_NOW_CONFIGURE: 'com_servicenow_configure',
  ARUBA_CENTRAL_CONFIGURE: 'com_config_aruba',
  DSCC_CONFIGURE: 'com_dscc_configure',
  SERVER_POWER_OFF: 'com_inventory_power_off',
  DOWNGRADE_COMPONENT: 'com_fw_compliance',
  ILO_SETTING_COMPONENT: 'com_iLO_compliance',
  RUN_SFW_COMPLIANCE_REPORT: '',
  SUSTAINABILITY_REPORTS: 'com_dc_issue',
  OV_APPLIANCE_SETTINGS: 'com_setting_ov_appliance_settings',
  COM_SECURITY_SETTINGS: 'com_security_settings',
  EXTERNAL_STORAGE_SETTINGS: 'com_serversetting_ex_storage',
  COPY_APPLIANCE_SERVER_TEMPLATES: 'com_copy_appliance_server_templates',
  APPLIANCE_SETTINGS: 'com_appliance_settings',
  COM_ILO_SETTINGS_CONFIG: 'com_group_ilo_settings',
  SERVER_HARDWARE_INVENTORY_ACTION: 'com_collect_hw',
  OS_INSTALLATION_COMPLETION_TIMEOUT: 'com_os_inst_timeout',
  APPLY_OV_APPLIANCE_SETTINGS: 'com_apply_OVA_appliance_settings',
  COM_ASSIGN_OV_LOC: 'com_assign_OV_loc',
  SECURE_GATEWAY_ACTIONS: 'com_secure_gateway_actions',
  COM_SG_APP: 'com_sg_app',
  COM_SG_APPLIANCE_CONFIG: 'com_sg_appliance_config',
  COM_ISUT_CONCEPT: 'com_isut_concept',
  COM_SEC_GATEWAY_OV_APPLIANCES: 'com_sec_gateway_ov_appliances',
  COM_ASSIGN_LOCATIONS: 'com_assign_locations',
  NEW_OV_SUBSCRIPTION: 'ov_service_sub_obtain',
  PIN_BASED_DIRECT_CONNECTED_SERVER_ONBOARDING: 'com_activate_with_pin',
  COM_DEV_SUB_ASSIGNMENT: 'com_dev_sub_assignment',
  SUSTAINABILITY_ANALYTICS: 'com_analytics',
  ILO_SSO: 'com_ilo_rc',
  SERVER_UTILIZATION_ANALYTICS: 'com_server_utilization_analytics',
  APPROVAL_POLICIES: 'com_approval_policies',
  SUBSCRIPTION_TIERS: 'com_subscription_tiers',
  COM_AHS_ANALYZER: '',
  COM_ADD_VCENTER: 'com_add_vcenter',
  COM_EDIT_VCENTER: 'com_edit_vcenter',
  COM_ADD_SERVER_CONCEPTS: 'com_add_server_concepts',
  COM_ADD_SERVER_LOCATION_TAGS: 'com_locations_tags',
  COM_SUBSCRIPTION_CREDENTIALS_SERVERS: 'com_subscription_cred_server',
  COM_WAIT_FOR_REBOOT: 'com_wait_for_reboot',
  COM_CREATE_SUPPORT_CASE: 'com_create_support_case',
  TEST_CONNECTION: 'com_test_connectivity',
  SERVER_LOG_COLLECTION: 'com_download_server_log',
  SECURE_GATEWAY: 'com_about_secure_gateway',
  BASELINE_EXCLUSION_CONFLICTS: 'cc_fw_baselines',
  ABOUT_EMAIL_NOTIFICATIONS: 'com_about_email_notifications',
  COM_SG_SERVER_DISCOVERY: 'com_sg_server_discovery',
  COM_FW_UPDATE_AT_DISCOVERY: 'com_fw_update_at_discovery',
  CONFIGURE_MAINTENANCE_MODE: 'com_maintenance_mode',
  COM_ADD_SERVER_DIRECT_CONNECT: '',
  COM_ADD_SERVER_SECURE_GATEWAY: '',
  FIRMWARE_BASELINE_HELP: '',
  COM_SECURE_HARDWARE_MONITORING: '',
  WHATS_NEW: 'com_new_features',
  // Avoid using dummy content ID in the file.
  // Use empty string if ID is not received from doc team.
};
